var config = require('../config.js')
module.exports = {
  getWeChatUserByCode: config.host + '/mkatl/api/v1/id/NA/getandlogin', // 用户登录, 小程序刚进入，以及 401 错误重新登录
  getQRCode: config.host + '/api/v1/QR/GenerateQR', // 获取小程序二维码
  getQRSceneOfShortCode: config.host + '/api/v1/QR/GetQRSceneOfShortCode', // 小程序二维码短参解析
  userLogin: config.host + '/api/v1/TenantID/' + config.tenantId + '/Login', // 用户登录
  getUserInfo: config.host + '/uc/api/v1/User/GetInfo', // 用户信息
  sendBindingCode: config.host + '/api/v1/ID/SendBindingCode', // 发送绑定验证码
  exchangePhone: config.host + '/api/v1/TenantID/' + config.tenantId + '/Exchange4Phone', // 微信手机号解码
  smsRegisterUser: config.host + '/cid/api/v1/sms-code/v2/registerUser', // 注册短信验证码
  userRegister: config.host + '/cid/api/v1/user/register/c',  // 注册用户
  userLoginH5: config.host + '/cid/api/v1/user/login/c',  // 用户登录
  userLoginWx: config.host + '/cid/api/v1/user/loginByWeChatMP/c',  // 微信授权登录
  userLoginDy: config.host + '/cid/api/v1/user/loginByDouYinMP/c',  // 抖音授权登录
  userOauthTokenH5: config.host + '/cid/oauth/token',  // 用户续期oauth/token?grant_type=refresh_token
  userExistsUser: config.host + '/cid/api/v1/user/existsUser/c',  // 用户是否存在
  businessWxAppId: config.host + '/tonpay/api/v1/config/wxAppId/c',  // 微信内获取商家appid
  smsNALogin: config.host + '/cid/api/v1/sms-code/v2/sendLoginCode',  // H5订票用户登录验证码
  smsResetPasswd: config.host + '/tktins/api/v1/sms/reset_passwd/c',  // 订票用户重置密码验证码
  getOpenId: config.host + '/cid/api/v1/user/code2openId/c',  // 微信code转openid
  getOpenIdByDouYin: config.host + '/cid/api/v1/user/codeDouYinOpenId/c',  // 抖音code转openid

  getPhoneVerifyCode: config.host + '/cid/api/v1/sms-code/verifyCode/c',  // 获取短信图形验证码
}